@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                 2 6 4 4 6.5 4c1.74 0 3.41 1 4.04 2.36C11.17 5 
                 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 
                 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Sending reset code...</p>
  </div>
}

@if (!isLoading) {
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card booking-card">
          <div
            class="card-header booking-card__header text-center justify-content-center flex-column pb-3"
          >
            <div class="booking-card__eyebrow">Account Recovery</div>
            <h2 class="sub-title mb-0 fs-3">Forgot Password</h2>
          </div>

          <div class="card-body p-4">
            <!-- Prominent Error Alert Banner -->
            @if (errorMessage) {
              <div
                class="alert alert-danger d-flex align-items-start mb-4 p-3 rounded-3 shadow-sm border-danger border-start border-4"
                role="alert"
              >
                <i
                  class="bi bi-exclamation-octagon-fill fs-4 me-3 text-danger flex-shrink-0 mt-1"
                ></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-danger">Request Failed</div>
                  <div class="small text-dark mt-1">{{ errorMessage }}</div>
                </div>
                <button
                  type="button"
                  class="btn-close ms-2"
                  (click)="errorMessage = null"
                  aria-label="Close error message"
                ></button>
              </div>
            }

            <p class="text-muted small text-center mb-4">
              Enter your registered email address to receive a secure recovery code.
            </p>

            <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForgotPassword()" novalidate>
              <!-- Email -->
              <div class="mb-4">
                <label for="email" class="form-label">Registered Email</label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="name@practice.com"
                  autocomplete="email"
                />
                @if (
                  forgotPasswordForm.controls['email'].touched &&
                  forgotPasswordForm.controls['email'].errors?.['required']
                ) {
                  <div class="text-danger small mt-1">Email is required.</div>
                }
                @if (
                  forgotPasswordForm.controls['email'].touched &&
                  forgotPasswordForm.controls['email'].errors?.['email']
                ) {
                  <div class="text-danger small mt-1">Enter a valid email address.</div>
                }
              </div>

              <!-- Submit -->
              <div class="d-grid">
                <button
                  type="submit"
                  class="btn btn-primary py-2"
                  [disabled]="forgotPasswordForm.invalid"
                >
                  <i class="bi bi-send me-1"></i> Send Verification Code
                </button>
              </div>

              <!-- Back to login -->
              <div class="text-center mt-4 pt-2 border-top">
                <small class="text-muted">
                  Remembered your credentials?
                  <a routerLink="/login" class="fw-bold text-primary text-decoration-none ms-1"
                    >Back to Login</a
                  >
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
}
